/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Architect_Output9Inputs */

const en_svc_ai_voice_agents_architect_output9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice architecture spec`)
};

const ar_svc_ai_voice_agents_architect_output9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مواصفة البنية الصوتية`)
};

const bn_svc_ai_voice_agents_architect_output9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভয়েস আর্কিটেকচার স্পেসিফিকেশন`)
};

const de_svc_ai_voice_agents_architect_output9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice-Architekturspezifikation`)
};

const es_svc_ai_voice_agents_architect_output9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificación de arquitectura de voz`)
};

const fr_svc_ai_voice_agents_architect_output9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spécification d'architecture vocale`)
};

const pt_svc_ai_voice_agents_architect_output9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificação de arquitetura de voz`)
};

const zh_svc_ai_voice_agents_architect_output9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语音架构规范`)
};

const tr_svc_ai_voice_agents_architect_output9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ses mimarisi şartnamesi`)
};

const ru_svc_ai_voice_agents_architect_output9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спецификация голосовой архитектуры`)
};

const pl_svc_ai_voice_agents_architect_output9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specyfikacja architektury głosowej`)
};

/**
* | output |
* | --- |
* | "Voice architecture spec" |
*
* @param {Svc_Ai_Voice_Agents_Architect_Output9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_architect_output9 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Architect_Output9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Architect_Output9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_architect_output9(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_architect_output9(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_architect_output9(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_architect_output9(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_architect_output9(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_architect_output9(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_architect_output9(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_architect_output9(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_architect_output9(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_architect_output9(inputs)
	return en_svc_ai_voice_agents_architect_output9(inputs)
});
export { svc_ai_voice_agents_architect_output9 as "svc_ai-voice-agents_ARCHITECT_output" }